<template>
	<div
		class="post"
		data-cy="post"
	>
		<component
			:is="formatBlockType(block.content_type)"
			v-for="(block, index) in blocks"
			:key="index"
			:block="block"
			:next="blocks[index + 1]"
			class="post-block"
		/>
	</div>
</template>

<script>
import ButtonBlock from './blocks/button-block/ButtonBlock.vue';
import CarouselBlock from './blocks/carousel-block/CarouselBlock.vue';
import ImageBlock from './blocks/image-block/ImageBlock.vue';
import SeparatorBlock from './blocks/separator-block/SeparatorBlock.vue';
import TextBlock from './blocks/text-block/TextBlock.vue';
import VideoBlock from './blocks/video-block/VideoBlock.vue';

export default {
	name: 'Post',

	components: {
		ButtonBlock,
		CarouselBlock,
		ImageBlock,
		SeparatorBlock,
		TextBlock,
		VideoBlock,
	},

	props: {
		blocks: {
			type: Array,
			required: true,
			description: 'Supplies the Post\'s content',
		},
	},
};
</script>

<style lang="scss" src="./post.scss" />
